import type { ReactNode } from 'react';
import { Icon, type IconName } from '@/components/icons';

export type ScreenFrameProps = {
  mode?: 'admin' | 'customer';
  /** When false, header still renders but without the tall dashboard hero accent. */
  hero?: boolean;
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  icon?: IconName;
};

export function ScreenFrame({
  mode = 'admin',
  hero = false,
  eyebrow,
  title,
  subtitle,
  actions,
  children,
  className = '',
  icon = 'settings',
}: ScreenFrameProps) {
  if (mode === 'customer') {
    return (
      <section className={`stack-gap customer-page ${className}`.trim()}>
        {hero ? (
          <section className="hero-card customer-hero-card">
            <div>
              {eyebrow ? <span>{eyebrow}</span> : null}
              <h2>{title}</h2>
              {subtitle ? <p>{subtitle}</p> : null}
            </div>
            {actions ? <div className="admin-page-actions">{actions}</div> : null}
          </section>
        ) : null}
        {children}
      </section>
    );
  }

  return (
    <div className={`admin-pro stack-gap ${className}`.trim()}>
      <section className={`admin-page-header ${hero ? 'vi-hero' : ''}`.trim()}>
        <div className="admin-page-title">
          <span className="section-icon">
            <Icon name={icon} size={24} />
          </span>
          <div>
            <h1>{title}</h1>
            {subtitle ? <p>{subtitle}</p> : null}
            {eyebrow && !subtitle ? <p>{eyebrow}</p> : null}
          </div>
        </div>
        {actions ? <div className="admin-page-actions">{actions}</div> : null}
      </section>
      {children}
    </div>
  );
}

export function ListTable({
  children,
  className = '',
  tableClassName = '',
  headers,
}: {
  children: ReactNode;
  className?: string;
  tableClassName?: string;
  headers?: string[];
}) {
  return (
    <div className={`pro-table-wrap ${className}`.trim()}>
      <table className={`pro-table ${tableClassName}`.trim()}>
        {headers && headers.length > 0 ? (
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
        ) : null}
        {children}
      </table>
    </div>
  );
}
